<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <div class="header">
      <van-nav-bar :title="ruleTitle" class="nav-bar">
        <template #left>
          <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
        </template>
      </van-nav-bar>
    </div>
    <div class="content">
      <van-pull-refresh :pulling-text="$t('loading.refresh')" :loading-text="$t('loading.loading')"  :loosing-text="$t('loading.loss')" :success-text="$t('loading.success')" v-model="isLoading" @refresh="onRefresh">
        <!-- 规则详情 单条展示 -->
        <div class="rule-detail" v-if="detail">
          <div class="rule-title">{{ detail.title }}</div>
          <div class="rule-content html" v-html="detail.content"></div>
          <div class="rule-time">{{ detail.create_time }}</div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      detail: null, // 详情数据
      ruleTitle: this.$t("mine.rules_detail"), // 导航标题
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    // 获取规则详情
    getRuleDetail() {
      this.$http({
        method: "get",
        url: "getSystemContent",
        data: {
          type: this.$route.query.type, 
        },
      }).then((res) => {
        console.log("规则详情", res);
        this.detail = res.data;
      });
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
        this.getRuleDetail();
      }, 500);
    },
  },
  created() {
    this.getRuleDetail();
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

::v-deep .van-pull-refresh__head * {
  color: #f3c7a2 !important;
  font-size: 32px !important;
}
::v-deep .van-loading__text {
  color: #f3c7a2 !important;
  font-size: 32px !important;
}

.container .content {
  height: calc(100% - 20px);
  overflow: auto;
  padding: 0 20px;
}

/* 规则详情样式 */
.rule-detail {
  padding: 20px 0;
  color: #f3c7a2;
}
.rule-title {
  font-size: 42px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
  line-height: 1.4;
}
.rule-content {
  font-size: 30px;
  line-height: 1.7;
  color: #f3c7a2;
  word-break: break-all;
  p {
    margin-bottom: 16px;
  }
}
.rule-time {
  text-align: right;
  font-size: 26px;
  color: #d4b08e;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #444;
}
</style>
